/**
 * Mock data for Student Dashboard V2
 *
 * This file contains mock data for visionary features that don't exist yet
 * in the current system, mixed with real data where available.
 */

export const MOCK_COURSIO_NETWORK_COURSES = [
  {
    id: 'cn-1',
    title: 'Advanced React Patterns',
    instructor: 'Sarah Johnson',
    instructorStore: 'DevMastery',
    category: 'Web Development',
    level: 'Advanced',
    duration: '8 hours',
    rating: 4.8,
    studentsCount: 1247,
    price: 49.99,
    currency: '€',
    thumbnailUrl: null,
    description: 'Master advanced React patterns including hooks, context, and performance optimization.',
    tags: ['React', 'JavaScript', 'Frontend'],
    relevanceScore: 95, // How relevant to student's current courses
    relevanceReason: 'Complements your JavaScript Fundamentals course',
  },
  {
    id: 'cn-2',
    title: 'TypeScript for Professionals',
    instructor: 'Michael Chen',
    instructorStore: 'CodeAcademy Pro',
    category: 'Programming',
    level: 'Intermediate',
    duration: '12 hours',
    rating: 4.9,
    studentsCount: 2156,
    price: 59.99,
    currency: '€',
    thumbnailUrl: null,
    description: 'Learn TypeScript from basics to advanced type systems and generics.',
    tags: ['TypeScript', 'JavaScript', 'Programming'],
    relevanceScore: 88,
    relevanceReason: 'Next step after JavaScript Fundamentals',
  },
  {
    id: 'cn-3',
    title: 'UI/UX Design Principles',
    instructor: 'Emma Rodriguez',
    instructorStore: 'DesignHub',
    category: 'Design',
    level: 'Beginner',
    duration: '6 hours',
    rating: 4.7,
    studentsCount: 892,
    price: 39.99,
    currency: '€',
    thumbnailUrl: null,
    description: 'Learn the fundamentals of user interface and user experience design.',
    tags: ['UI', 'UX', 'Design'],
    relevanceScore: 75,
    relevanceReason: 'Enhance your web development skills',
  },
  {
    id: 'cn-4',
    title: 'Node.js Backend Development',
    instructor: 'David Kim',
    instructorStore: 'BackendMasters',
    category: 'Backend Development',
    level: 'Intermediate',
    duration: '10 hours',
    rating: 4.8,
    studentsCount: 1543,
    price: 54.99,
    currency: '€',
    thumbnailUrl: null,
    description: 'Build scalable backend applications with Node.js and Express.',
    tags: ['Node.js', 'Backend', 'JavaScript'],
    relevanceScore: 92,
    relevanceReason: 'Perfect complement to your frontend skills',
  },
  {
    id: 'cn-5',
    title: 'CSS Grid & Flexbox Mastery',
    instructor: 'Lisa Anderson',
    instructorStore: 'CSSExperts',
    category: 'Web Development',
    level: 'Intermediate',
    duration: '5 hours',
    rating: 4.9,
    studentsCount: 1876,
    price: 34.99,
    currency: '€',
    thumbnailUrl: null,
    description: 'Master modern CSS layout techniques with Grid and Flexbox.',
    tags: ['CSS', 'Layout', 'Frontend'],
    relevanceScore: 85,
    relevanceReason: 'Build on your Web Design Basics knowledge',
  },
  {
    id: 'cn-6',
    title: 'Git & GitHub for Teams',
    instructor: 'James Wilson',
    instructorStore: 'DevOps Academy',
    category: 'Development Tools',
    level: 'Beginner',
    duration: '4 hours',
    rating: 4.7,
    studentsCount: 2341,
    price: 29.99,
    currency: '€',
    thumbnailUrl: null,
    description: 'Learn version control and collaboration with Git and GitHub.',
    tags: ['Git', 'GitHub', 'Version Control'],
    relevanceScore: 80,
    relevanceReason: 'Essential skill for all developers',
  },
];

export const MOCK_ACHIEVEMENTS = [
  {
    id: 'ach-1',
    title: 'Fast Learner',
    description: 'Completed 3 courses in one month',
    icon: 'Bolt',
    earnedDate: '2025-01-15',
    rarity: 'rare', // common, rare, epic, legendary
    progress: 100,
  },
  {
    id: 'ach-2',
    title: 'Perfect Score',
    description: 'Scored 100% on 5 quizzes',
    icon: 'Certificate',
    earnedDate: '2025-01-20',
    rarity: 'epic',
    progress: 100,
  },
  {
    id: 'ach-3',
    title: 'Streak Master',
    description: 'Maintained a 30-day learning streak',
    icon: 'TrendingUp',
    earnedDate: null, // Not earned yet
    rarity: 'legendary',
    progress: 73, // 22 out of 30 days
  },
  {
    id: 'ach-4',
    title: 'Course Collector',
    description: 'Enrolled in 10 courses',
    icon: 'Course',
    earnedDate: null,
    rarity: 'rare',
    progress: 60, // 6 out of 10
  },
];

export const MOCK_LEARNING_STREAK = {
  currentStreak: 22,
  longestStreak: 35,
  totalDaysLearned: 127,
  lastActivityDate: '2025-01-25',
  streakHistory: [
    { date: '2025-01-19', completed: true },
    { date: '2025-01-20', completed: true },
    { date: '2025-01-21', completed: true },
    { date: '2025-01-22', completed: true },
    { date: '2025-01-23', completed: true },
    { date: '2025-01-24', completed: true },
    { date: '2025-01-25', completed: true },
  ],
};

export const MOCK_UPCOMING_DEADLINES = [
  {
    id: 'dl-1',
    courseId: 'course-1',
    courseTitle: 'JavaScript Fundamentals',
    taskTitle: 'Final Project Submission',
    taskType: 'assignment',
    dueDate: '2025-02-01',
    priority: 'high',
    completed: false,
  },
  {
    id: 'dl-2',
    courseId: 'course-2',
    courseTitle: 'Web Design Basics',
    taskTitle: 'Quiz: CSS Flexbox',
    taskType: 'quiz',
    dueDate: '2025-01-28',
    priority: 'medium',
    completed: false,
  },
  {
    id: 'dl-3',
    courseId: 'course-1',
    courseTitle: 'JavaScript Fundamentals',
    taskTitle: 'Module 5 Completion',
    taskType: 'module',
    dueDate: '2025-01-30',
    priority: 'low',
    completed: false,
  },
];

export const MOCK_CERTIFICATES = [
  {
    id: 'cert-1',
    courseId: 'course-completed-1',
    courseTitle: 'HTML & CSS Basics',
    issuedDate: '2024-12-15',
    certificateUrl: '#',
    instructor: 'John Doe',
    score: 95,
  },
  {
    id: 'cert-2',
    courseId: 'course-completed-2',
    courseTitle: 'Introduction to Programming',
    issuedDate: '2024-11-20',
    certificateUrl: '#',
    instructor: 'Jane Smith',
    score: 88,
  },
];

export const MOCK_LEARNING_GOALS = {
  weeklyGoal: {
    target: 5, // hours
    current: 3.5,
    unit: 'hours',
  },
  monthlyGoal: {
    target: 3, // courses
    current: 1,
    unit: 'courses',
  },
  yearlyGoal: {
    target: 20, // courses
    current: 8,
    unit: 'courses',
  },
};

export const MOCK_RECENT_ACTIVITY = [
  {
    id: 'act-1',
    type: 'course_progress',
    courseTitle: 'JavaScript Fundamentals',
    action: 'Completed Module 4: Functions',
    timestamp: '2025-01-25T14:30:00',
    icon: 'Check',
  },
  {
    id: 'act-2',
    type: 'quiz_completed',
    courseTitle: 'Web Design Basics',
    action: 'Scored 92% on CSS Grid Quiz',
    timestamp: '2025-01-24T10:15:00',
    icon: 'Certificate',
  },
  {
    id: 'act-3',
    type: 'course_enrolled',
    courseTitle: 'Advanced JavaScript',
    action: 'Enrolled in new course',
    timestamp: '2025-01-23T16:45:00',
    icon: 'Course',
  },
  {
    id: 'act-4',
    type: 'certificate_earned',
    courseTitle: 'HTML & CSS Basics',
    action: 'Earned certificate',
    timestamp: '2024-12-15T09:00:00',
    icon: 'Certificate',
  },
];

export const MOCK_PERSONALIZED_RECOMMENDATIONS = {
  basedOnProgress: [
    {
      id: 'rec-1',
      title: 'Continue JavaScript Fundamentals',
      description: "You're 75% through! Finish Module 5 to complete the course.",
      courseId: 'course-1',
      priority: 'high',
      icon: 'Play',
    },
  ],
  basedOnInterests: [
    {
      id: 'rec-2',
      title: 'Try Advanced CSS Techniques',
      description: 'Based on your progress in Web Design Basics',
      courseId: null,
      priority: 'medium',
      icon: 'Lightbulb',
    },
  ],
};

export const MOCK_NOTIFICATIONS = [
  {
    id: 'notif-1',
    type: 3, // postAdded - new discussion message
    courseTitle: 'JavaScript Fundamentals',
    message: 'New message in "Introduction to Variables" discussion',
    timestamp: '2025-01-25T16:30:00',
    isRead: false,
    icon: 'Feedback',
    link: '/course/1/page/5',
  },
  {
    id: 'notif-2',
    type: 2, // taskFeedback
    courseTitle: 'Web Design Basics',
    message: 'Your instructor gave feedback on "CSS Grid Assignment"',
    timestamp: '2025-01-25T14:15:00',
    isRead: false,
    icon: 'Feedback',
    link: '/course/2/page/12',
  },
  {
    id: 'notif-3',
    type: 8, // threadNewPost
    courseTitle: 'JavaScript Fundamentals',
    message: '3 new replies in "Async/Await Discussion"',
    timestamp: '2025-01-25T10:45:00',
    isRead: true,
    icon: 'Users',
    link: '/course/1/page/8',
  },
  {
    id: 'notif-4',
    type: 14, // dripContent
    courseTitle: 'Advanced React Patterns',
    message: 'New module "Custom Hooks" is now available',
    timestamp: '2025-01-24T09:00:00',
    isRead: true,
    icon: 'Lock',
    link: '/course/3/page/15',
  },
  {
    id: 'notif-5',
    type: 12, // addedToCourse
    courseTitle: 'TypeScript Masterclass',
    message: 'You have been enrolled in a new course',
    timestamp: '2025-01-23T11:20:00',
    isRead: true,
    icon: 'Course',
    link: '/course/4',
  },
];

export default {
  MOCK_COURSIO_NETWORK_COURSES,
  MOCK_ACHIEVEMENTS,
  MOCK_LEARNING_STREAK,
  MOCK_UPCOMING_DEADLINES,
  MOCK_CERTIFICATES,
  MOCK_LEARNING_GOALS,
  MOCK_RECENT_ACTIVITY,
  MOCK_PERSONALIZED_RECOMMENDATIONS,
  MOCK_NOTIFICATIONS,
};
